<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_DELAY = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Debounce-Timer und Sequenz liegen bewusst je Komponenteninstanz vor.
    this.debounceTimer = null;
    this.searchSeq = 0;
    this.geocoder = null;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        geocoder.destroy();
        return;
      }
      this.geocoder = geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.clearDebounce();
    this.searchSeq++;
    if (this.geocoder) {
      this.geocoder.destroy();
    }
  },

  watch: {
    search(val) {
      // Leere Eingabe und Auswahl beenden Timer und laufende Anfragen.
      if (!val || val === this.select) {
        this.resetPending();
        if (!val) {
          this.items = [];
        }
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    clearDebounce() {
      if (this.debounceTimer !== null) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    },

    resetPending() {
      this.clearDebounce();
      this.searchSeq++;
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      this.loading = false;
    },

    querySelections(value) {
      this.clearDebounce();
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      const seq = ++this.searchSeq;
      this.loading = true;

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;

        if (seq !== this.searchSeq) {
          return;
        }
        if (!this.geocoder) {
          this.loading = false;
          return;
        }

        this.geocoder
          .autocomplete(value)
          .then(items => {
            // Nur die juengste Suche darf Treffer setzen.
            if (seq !== this.searchSeq) {
              return;
            }
            this.items = Array.isArray(items) ? items.slice() : [];
          })
          .catch(() => {
            if (seq !== this.searchSeq) {
              return;
            }
            this.items = [];
          })
          .then(() => {
            // Ein veraltetes Ende darf den Ladezustand nicht zuruecksetzen.
            if (seq === this.searchSeq) {
              this.loading = false;
            }
          });
      }, DEBOUNCE_DELAY);
    },

    change(o) {
      this.$emit("change", o);
    }
  }
};
</script>
